import { lazy, Suspense, forwardRef } from 'react';
import type { EditorRef } from '../../types';
import type { RichEditorProps } from './types';

export const importBaseRichTextEditor = () =>
  import(
    /* webpackChunkName: "RichTextEditor" */
    './BaseRichTextEditor'
  );

const LazyRichTextEditor = lazy(importBaseRichTextEditor);

export const RichTextEditor = forwardRef<EditorRef, RichEditorProps>((props, ref) => {
  return (
    <Suspense>
      <LazyRichTextEditor {...props} ref={ref} />
    </Suspense>
  );
});

RichTextEditor.displayName = 'RichTextEditor';
